module.exports = __webpack_public_path__ + "img/clock.0bd5c79a.png";